import { Tooltip } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import { ReactComponent as IconTable } from "assets/icon_table_th.svg";
import { ReactComponent as MapAnalysisSvg } from "assets/map_analysis.svg";
import { ReactComponent as NotAnalysisSvg } from "assets/notAnalysis.svg";
import Icon from "components/icon/icon";
import { AppAction, AppContext } from "helpers/context";
import { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import EventDetails from "./event-detail/event-detail";
import EventImpactTable from "./event-impact-table/event-impact-table";
import styles from "./event-multiple-results.module.scss";
import TryAgain from "components/tryAgain/tryAgain";
import { handleFilterLocations } from "helpers/helpers";

export default function EventMultipleResults() {
  const [context, dispatch] = useContext(AppContext);
  const [count, setCount] = useState<number>(0);
  const [t] = useTranslation();
  const [locationsTable, setLocationsTable] = useState<any[]>([])
  const unit = context.currentMultipleLocations?.aggregationUnit ?? "numberOfLocations";

  useEffect(() => {
    let data = handleFilterLocations({
      data: context.currentMultipleLocations?.items || [],
      unit: unit,
      multipleLocationsSearch: context.multipleLocationsSearch,
      locationsFilterInfo: context.locationsFilterInfo,
    })

    setLocationsTable(data)
  }, [context.currentMultipleLocations?.items, context.multipleLocationsSearch, context.locationsFilterInfo, unit])


  const handleRetry = () => {
    dispatch({ type: AppAction.setTryAgainType, payload: "analyse" });
  }

  const showInfo = () => {
    dispatch({ type: AppAction.setShowLocationAnalysisDetails, payload: true });
  };

  if (context.eventAnalysisStatus && context.eventAnalysisStatus === "error") {
    return (<TryAgain handleRetry={handleRetry} />);
  }

  if (
    context.eventAnalysisStatus &&
    context.eventAnalysisStatus === "running"
  ) {
    return (
      <div className="h-full flex flex-col items-center justify-center">
        <LinearProgress
          color="success"
          style={{ width: "40%", marginBottom: "10px" }}
        />
        <div>{t("multiple.eventAlalyseLoadingContent")}</div>
      </div>
    );
  }

  if (!context.eventAnalysisLegend || context.eventAnalysisLegend.length === 0) {
    return (
      <div className="h-full flex flex-col items-center justify-center">
        <NotAnalysisSvg className="w-[60px] h-[60px] mx-auto mb-4" />
        <div style={{ color: "var(--gray-text)" }}>
          {t("single.notMultipleAnalysis")}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={styles.locationInfo}>
        <div className="flex justify-between items-center">
          <span className="text-[#000000de] text-[13px] font-medium">
            {t("multiple.overview")}
          </span>
          <div className="flex items-center">
            <div className="mt-[3px] flex items-center">
              <Tooltip placement="top" title={t("results.resultsFor")}>
                <span>{t("results.resultsFor")}</span>
              </Tooltip>
              <MapAnalysisSvg className="w-[24px] h-[24px] fill-[#0009] mx-[5px] mt-[-5px]" />
              <Tooltip
                placement="top"
                title={`${count} / ${locationsTable.filter(v => v.checked).length} ${t("results.locations")}`}
              >
                <span>
                  {count} {" / "} {locationsTable.filter(v => v.checked).length}
                  {t("results.locations")}
                </span>
              </Tooltip>
            </div>
            <Icon icon="info" type="outlined" onClick={showInfo}></Icon>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingRight: "10px",
          marginTop: "10px",
          marginRight: "0.75rem"
        }}
      >
        <p className="m-2 font-bold">{t("events.Impact")}</p>
        <div
          style={{
            padding: "6px 10px",
            borderRadius: "5px",
            backgroundColor: "var(--green-hover)",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)"
          }}
        >
          <IconTable />
        </div>
      </div>
      <EventImpactTable setCount={setCount} locationsTable={locationsTable} />

      <EventDetails />
    </>
  );
}


